import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import ApiClient from '@afosto/api/ApiClient';

const AsyncSelect = ({
  name,
  suggestionLabelKey,
  suggestionValueKey,
  url,
  params,
  requestOptions,
  ...selectProps
}) => {
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const fetchSuggestions = async () => {
      try {
        const formattedParams = Object.keys(params ?? {}).reduce((acc, paramKey) => {
          let paramValue = params[paramKey];

          if (typeof paramValue === 'function') {
            paramValue = params[paramKey]();
          }

          return { ...acc, [paramKey]: paramValue };
        }, {});
        const response = await ApiClient.request({
          url,
          params: formattedParams,
          ...requestOptions,
        });
        const { data = [] } = response;
        const formattedSuggestions = data.reduce(
          (acc, result) => [
            ...acc,
            {
              label: result?.[suggestionLabelKey] ?? '',
              value: result?.[suggestionValueKey] ?? '',
            },
          ],
          [],
        );

        setSuggestions(formattedSuggestions);
      } catch (err) {
        setSuggestions([]);
      }
    };

    if (url) {
      fetchSuggestions().catch(() => {
        // Catch only.
      });
    }
  }, [url, requestOptions, params, suggestionLabelKey, suggestionValueKey]);

  return <Select {...selectProps} name={name} suggestions={suggestions} />;
};

AsyncSelect.propTypes = {
  name: PropTypes.string.isRequired,
  params: PropTypes.object,
  requestOptions: PropTypes.object,
  suggestionLabelKey: PropTypes.string,
  suggestionValueKey: PropTypes.string,
  url: PropTypes.string.isRequired,
};

AsyncSelect.defaultProps = {
  params: {},
  requestOptions: {},
  suggestionLabelKey: 'label',
  suggestionValueKey: 'value',
};

export default AsyncSelect;
